import React from 'react';
import { Box, IconShipping24, Text } from '@stitch-fix/mode-react';
import cx from 'classnames';
import './styles.module.scss';

/**
 * Displays "Shipping & Returns" details and links
 */
const ShippingDetails = ({ mobile }: ShippingDetailsProps) => {
  return (
    <Box
      styleName={cx('shipping-details', { mobile })}
      pt={{ sm: 0.875, md: 0.5 }}
      pb={0.5}
    >
      <IconShipping24 styleName="icon" title="Shipping Icon" />
      <Text setting="body-small" ml={0.5}>
        Free shipping, returns & exchanges
      </Text>
    </Box>
  );
};

interface ShippingDetailsProps {
  mobile?: boolean;
}

const defaultProps: ShippingDetailsProps = {
  mobile: false,
};

ShippingDetails.defaultProps = defaultProps;

export default ShippingDetails;
